export default "__VITE_ASSET__CB75g$WR__"